"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const redux_1 = require("redux");
const actions_1 = require("../scheduler/actions");
const actions_2 = require("./actions");
exports.initialState = {
    isAuthorized: false,
    isLicenseValid: false,
    user: null,
    role: null,
    isFetching: false,
    isFetchingUserData: false,
    isSalesforceAuthorizationCodeFetching: false,
    isSalesforceLoginFetching: false,
};
const isAuthorized = (state = exports.initialState.isAuthorized, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.SET_IS_AUTHORIZED:
            return action.payload;
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_FAILURE:
            return false;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isAuthorized;
        default:
            return state;
    }
};
const isLicenseValid = (state = exports.initialState.isLicenseValid, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.SET_IS_LICENSE_VALID:
            return action.payload;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isLicenseValid;
        default:
            return state;
    }
};
const user = (state = exports.initialState.user, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.SET_USER:
            return action.payload;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.user;
        default:
            return state;
    }
};
const role = (state = exports.initialState.role, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.SET_ROLE:
            return action.payload;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.role;
        default:
            return state;
    }
};
const isFetching = (state = exports.initialState.isFetching, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_REQUEST:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_REQUEST:
        case actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST:
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FETCHING:
            return true;
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_FAIL:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_FAIL:
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FAIL:
        case actions_2.SUMOCEPUserActionTypes.SET_IS_FETCHING:
            return false;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetching;
        default:
            return state;
    }
};
const isFetchingUserData = (state = exports.initialState.isFetchingUserData, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_REQUEST:
            return true;
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FAIL:
            return false;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetchingUserData;
        default:
            return state;
    }
};
const isSalesforceAuthorizationCodeFetching = (state = exports.initialState.isSalesforceAuthorizationCodeFetching, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_REQUEST:
            return true;
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_FAIL:
            return false;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSalesforceAuthorizationCodeFetching;
        default:
            return state;
    }
};
const isSalesforceLoginFetching = (state = exports.initialState.isSalesforceLoginFetching, action) => {
    switch (action.type) {
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_REQUEST:
        case actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST:
            return true;
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST_SUCCESS:
        case actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_FAIL:
            return false;
        case actions_2.SUMOCEPUserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSalesforceLoginFetching;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    isAuthorized,
    isLicenseValid,
    user,
    role,
    isFetching,
    isFetchingUserData,
    isSalesforceLoginFetching,
    isSalesforceAuthorizationCodeFetching,
});
